import { TableBodyCell } from '../../../../../MyTickets.styled';
import { PriorityCellProps } from './PriorityCell.types';
import { ticketPriorityLookUp } from 'src/components/Tickets/MyTickets.constants';

export const PriorityCell = ({ priority }: PriorityCellProps) => {
  return <TableBodyCell>{ticketPriorityLookUp[priority].label}</TableBodyCell>;
};
